var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "200",
        height: "200",
        viewBox: "0 0 200 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M99.9371 149.408C99.9371 177.005 77.5654 199.377 49.9685 199.377C22.3717 199.377 0 177.005 0 149.408C0 121.812 22.3717 99.4398 49.9685 99.4398C77.5654 99.4398 99.9371 121.812 99.9371 149.408Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M74.7259 106.004C67.1839 101.702 58.6511 99.4398 49.9685 99.4398V148.056L94.3205 172.425C98.1302 165.084 100.061 156.906 99.9309 148.624C99.7945 139.942 97.3984 131.446 92.9786 123.972C88.5587 116.499 82.2679 110.306 74.7259 106.004Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M94.2306 172.597L93.2761 174.335C93.4388 174.052 93.5989 173.767 93.7563 173.481C93.9175 173.188 94.0756 172.893 94.2306 172.597Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M93.1138 174.614L48.7018 150.212L7.77871 176.183C12.4311 183.514 18.9134 189.506 26.5868 193.569C34.2602 197.632 42.8598 199.625 51.5381 199.352C60.2164 199.08 68.6739 196.55 76.077 192.014C83.1095 187.704 88.96 181.725 93.1138 174.614Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M173.274 32.7741C181.1 32.7741 187.444 26.4299 187.444 18.6039C187.444 10.778 181.1 4.43375 173.274 4.43375C165.448 4.43375 159.104 10.778 159.104 18.6039C159.104 26.4299 165.448 32.7741 173.274 32.7741Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M173.274 64.0978C181.1 64.0978 187.444 57.7536 187.444 49.9276C187.444 42.1016 181.1 35.7574 173.274 35.7574C165.448 35.7574 159.104 42.1016 159.104 49.9276C159.104 57.7536 165.448 64.0978 173.274 64.0978Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M129.52 32.7741C137.346 32.7741 143.691 26.4299 143.691 18.6039C143.691 10.778 137.346 4.43375 129.52 4.43375C121.694 4.43375 115.35 10.778 115.35 18.6039C115.35 26.4299 121.694 32.7741 129.52 32.7741Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M143.691 49.9276C143.691 57.7536 137.346 64.0978 129.52 64.0978C121.694 64.0978 115.35 57.7536 115.35 49.9276C115.35 42.1016 121.694 35.7574 129.52 35.7574C137.346 35.7574 143.691 42.1016 143.691 49.9276Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M129.52 95.4211C137.346 95.4211 143.691 89.0769 143.691 81.2509C143.691 73.425 137.346 67.0807 129.52 67.0807C121.694 67.0807 115.35 73.425 115.35 81.2509C115.35 89.0769 121.694 95.4211 129.52 95.4211Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M173.274 95.4211C181.1 95.4211 187.444 89.0769 187.444 81.2509C187.444 73.425 181.1 67.0807 173.274 67.0807C165.448 67.0807 159.104 73.425 159.104 81.2509C159.104 89.0769 165.448 95.4211 173.274 95.4211Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M0 0H99.9371V99.9371H0V0Z", fill: "black" } }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M33.3124 0H0V99.9371L32.0623 99.9371V68.1234H0.248617V65.6234H32.0623V34.811H0.248617V32.311H32.0623V0.497335H33.3124V0Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M99.6885 66.6248V68.1234H67.8749V99.9372L99.9371 99.9371L99.9369 66.6248H99.6885Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M65.3749 99.9372V68.1234L34.5623 68.1234V99.9371L65.3749 99.9372Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M65.3749 34.811V65.6234L34.5623 65.6234V34.811L65.3749 34.811Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M200 199.792H99.8962V99.6885H200V199.792Z", fill: "black" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M200 165.022V134.21H167.966V165.022H200Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M200 131.71V99.6879L133.222 99.6878V99.8961H134.431V131.71H165.466V99.8961H167.966V131.71H200Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M166.355 200L99.8964 200V167.522H131.931V200H134.431V167.522H165.466V200H166.355Z",
          fill: "#2C6FEF"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M99.8964 165.022H131.931V134.21H99.8964V165.022Z",
          fill: "#2C6FEF"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }